import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';

export enum CancellationNavigationEnum {
  REFUND_STARTED = 'REFUND_STARTED',
  CANCELLATION_STARTED = 'CANCELLATION_STARTED',
  CANCELLATION_ACCEPTED = 'CANCELLATION_ACCEPTED',
  PROCESSING_CANCELLATION = 'PROCESSING_CANCELLATION',
  CANCELLATION_REFUSED = 'CANCELLATION_REFUSED',
  CANCELLATION_FINISHED = 'CANCELLATION_FINISHED',
  CANCELLATION_NOT_STARTED = 'CANCELLATION_NOT_STARTED',
}

export enum ContractingCancellationStateEnum {
  CANCELLATION_STARTED = 'CANCELLATION_STARTED',
  PROCESSING_CANCELLATION = 'PROCESSING_CANCELLATION',
  CANCELLATION_FINISHED = 'CANCELLATION_FINISHED',
}

export const CancellationAllowedEnum = [
  OnlineContractingStateEnum.ContractingFinished,
  OnlineContractingStateEnum.ProcessingBilling,
  OnlineContractingStateEnum.WaitingBilling,
];
